import React from 'react';
import logo from '../../assets/tourneylogo.webp';

function Sidebar({ active }) {
  return (
    <div className="sidebar">
      <a href="/" className="sidebar-logo">
        <img src={logo} alt="Manifold Tournaments logo" className="tourney-logo" />
        <span>Manifold Tournaments</span>
      </a>
      <nav className="sidebar-nav">
        <a
          href="/"
          className={`nav-item ${active === 'landing' ? 'active' : ''}`}
        >
          🏆 All Tournaments
        </a>
        <a
          href="/halloffame.html"
          className={`nav-item ${active === 'halloffame' ? 'active' : ''}`}
        >
          🏛️ Hall of Fame
        </a>
        <a
          href="/user.html"
          className={`nav-item ${active === 'user' ? 'active' : ''}`}
        >
          👤 User Lookup
        </a>
        <a
          href="/about.html"
          className={`nav-item ${active === 'about' ? 'active' : ''}`}
        >
          ℹ️ About
        </a>
        <a
          href="/admin.html?new=1"
          className="nav-item nav-item-cta"
        >
          ➕ Create Tournament
        </a>
      </nav>
      <div className="sidebar-footer">
        Unofficial · built on{' '}
        <a href="https://manifold.markets" target="_blank" rel="noopener noreferrer">
          Manifold
        </a>
      </div>
    </div>
  );
}

export default function TournamentsLayout({ active, children }) {
  return (
    <div className="tournaments-app">
      <Sidebar active={active} />
      <main className="main-content">{children}</main>
    </div>
  );
}
